// External dependencies
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

export class OfferPricingPresentational extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { offer, t, isOwnOffer, username } = this.props;

    return (
      <div className="offer-pricing panel panel-default offer-view mt-3 shadow-sm border-0">
        <div className="panel-heading fw-bold fs-5 bg-light p-3 rounded-top">
          {t('Hosting Fee')}
        </div>
        <div className="panel-body">
          <div className="price-scroll">
            {offer?.prices?.length > 0 ? (
              offer.prices.map(({ type, price }) => (
                <a
                  key={type}
                  href={isOwnOffer ? '/offer/host' : `/messages/${username}`}
                >
                  <div key={type} className="price-box">
                    <span className="type">{t(type)}</span>
                    <span className="price">
                      {price === 0 ? t('Free') : `€${price}`}
                    </span>
                  </div>
                </a>
              ))
            ) : (
              <div className="no-price">{t('No hosting fee available')}</div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

OfferPricingPresentational.propTypes = {
  offer: PropTypes.object.isRequired,
  t: PropTypes.func,
  isOwnOffer: PropTypes.bool,
  username: PropTypes.string,
};

export default withTranslation(['offers'])(OfferPricingPresentational);
